import { createTheme } from '@mui/material';

import localStorageService from '../../features/shared/services/local-storage/local-storage.service';
import { castTo } from '../../features/shared/utils/cast-to';
import { ThemeEnum } from './enums/theme.enum';
import { palettesDef } from './palettes-def';

export const globalTheme = createTheme({
  palette: palettesDef.get(
    castTo<ThemeEnum>(localStorageService.get('themePalette')) ??
      ThemeEnum.SPARQ
  ),
});
